/**
 * Lucide icons — loaded only on pages that render icon placeholders.
 *
 * Replaces any `[data-lucide]` element with the matching Lucide SVG.
 * Icon names come from the Technical Capability taxonomy (field_icon_name).
 */
import { createIcons, icons } from 'lucide';

((Drupal) => {
  Drupal.behaviors.rhinoLucide = {
    attach(context) {
      const els = once('rh-lucide', '[data-lucide]', context);
      if (!els.length) return;

      createIcons({
        icons,
        nameAttr: 'data-lucide',
        attrs: { 'stroke-width': 1.5, 'aria-hidden': 'true' },
      });
    },
  };
})(Drupal);
